


























import Vue from "vue";
import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ActionButton",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["exSmall", "small", "medium", "large"].includes(value);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bezel: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: "normal",
      validator(value) {
        return [
          "normal",
          "primary",
          "secondary",
          "destructive",
          "cancel"
        ].includes(value);
      }
    },
    iconName: {
      type: String,
      default: ""
    },
    round: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      style: {}
    };
  },
  computed: {
    themeClass() {
      return {
        "button--theme--normal": this.theme === "normal",
        "button--theme--primary": this.theme === "primary",
        "button--theme--secondary": this.theme === "secondary",
        "button--theme--destructive": this.theme === "destructive",
        "button--theme--cancel": this.theme === "cancel"
      };
    },
    sizeClass() {
      return {
        "button--size--medium": this.size === "medium",
        "button--size--large": this.size === "large"
      };
    },
    bezelClass() {
      return {
        "button--bezel": this.bezel
      };
    },
    loadingClass() {
      return {
        "button--loading": this.loading
      };
    },
    iconClass() {
      return {
        "button--icon": !!this.iconName
      };
    },
    roundClass() {
      return {
        "button--round": this.round
      };
    }
  },
  watch: {
    loading() {
      this.loadingWidth();
    }
  },
  methods: {
    handleClick() {
      sendGaEvent(this);
      this.$emit("click");
    },
    loadingWidth() {
      const button = this.$refs.button as HTMLElement;
      if (this.loading) {
        this.$set(
          this.style,
          "width",
          `${button.getBoundingClientRect().width}px`
        );
      } else {
        this.$delete(this.style, "width");
      }
    }
  }
});
